jQuery(document).ready(function ($) {
    $('a[href="#"]').click(function (e) {
        e.preventDefault();
    });

    $('[data-toggle]').on('click', function () {
        let toggle_name = $(this).data('toggle');
        let target_name = $(this).data('target');
        let target_element = $('[data-toggle="showbox"][data-target="' + target_name + '"]');

        if (toggle_name == 'openbox') {
            let target_status = target_element.data('status');
            $('[data-toggle="showbox"]:not([data-target="' + target_name + '"])').attr('data-status', false);

            if (target_status == false) {
                target_element.attr('data-status', true);
            } else {
                target_element.attr('data-status', false);
            }
        } else if (toggle_name == 'closebox') {
            target_element.attr('data-status', false);
        }
    });

    $(document).on('click', function () {
        $('[data-toggle="showbox"]').attr('data-status', false);
    });

    $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
            $('[data-toggle="showbox"]').attr('data-status', false);
        }
    });

    $('[data-toggle="showbox"],[data-toggle="openbox"]').click(function (event) {
        event.stopPropagation();
    });

    // Tabs
    //=====================================================================

    $(document).on('click', 'li[data-tab]', function () {
        let $this = $(this),
            tab = $this.data('tab'),
            target = $this.data('tab-target');

        $this.addClass('active').siblings().removeClass('active');

        $('.tab-content[data-tab-target="' + target + '"][data-tab="' + tab + '"]')
            .addClass('active')
            .siblings()
            .removeClass('active');
    });

    // Toaster Alert
    //=====================================================================

    // const Toast = Swal.mixin({
    //     toast: true,
    //     position: 'top-end',
    //     showConfirmButton: false,
    //     timer: 3000,
    //     timerProgressBar: true,
    //     onOpen: (toast) => {
    //         toast.addEventListener('mouseenter', Swal.stopTimer)
    //         toast.addEventListener('mouseleave', Swal.resumeTimer)
    //     }
    // });

    // Toast.fire({
    //     icon: 'success',
    //     title: 'توستر',
    //     footer: 'این تست توستر است',
    // });

    //ToTop
    $(window).scroll(function () {
        if ($(window).scrollTop() >= 300) {
            $('#totop').fadeIn(1000);
        } else {
            $('#totop').fadeOut(1000);
        }
    });

    $('#totop').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        return false;
    });

    // Gallery Main
    // Gallery image hover
    $('.img-wrapper-ga').hover(
        function () {
            $(this).find('.img-overlay-ga').animate({ opacity: 1 }, 600);
        },
        function () {
            $(this).find('.img-overlay-ga').animate({ opacity: 0 }, 600);
        }
    );

    // Lightbox
    var $overlay = $('<div id="overlay-ga"></div>');
    var $image = $('<img>');
    var $prevButton = $('<div id="prevButton"><i class="ms-arrow-left"></i></div>');
    var $nextButton = $('<div id="nextButton"><i class="ms-arrow-right"></i></div>');
    var $exitButton = $('<div id="exitButton"><i class="fa fa-times">X</i></div>');

    // Add overlay
    $overlay.append($image).prepend($prevButton).append($nextButton).append($exitButton);
    $('#gallery-main').append($overlay);

    // Hide overlay on default
    $overlay.hide();

    // When an image is clicked
    $('.img-overlay-ga').click(function (event) {
        // Prevents default behavior
        event.preventDefault();
        // Adds href attribute to variable
        var imageLocation = $(this).prev().attr('href');
        // Add the image src to $image
        $image.attr('src', imageLocation);
        // Fade in the overlay
        $overlay.fadeIn('slow');
    });

    // When the overlay is clicked
    $overlay.click(function () {
        // Fade out the overlay
        $(this).fadeOut('slow');
    });

    // When next button is clicked
    $nextButton.click(function (event) {
        // Hide the current image
        $('#overlay-ga img').hide();
        // Overlay image location
        var $currentImgSrc = $('#overlay-ga img').attr('src');
        // Image with matching location of the overlay image
        var $currentImg = $('#image-gallery-ga img[src="' + $currentImgSrc + '"]');
        // Finds the next image
        var $nextImg = $($currentImg.closest('.image-ga').next().find('img'));
        // All of the images in the gallery
        var $images = $('#image-gallery-ga img');
        // If there is a next image
        if ($nextImg.length > 0) {
            // Fade in the next image
            $('#overlay-ga img').attr('src', $nextImg.attr('src')).fadeIn(800);
        } else {
            // Otherwise fade in the first image
            $('#overlay-ga img').attr('src', $($images[0]).attr('src')).fadeIn(800);
        }
        // Prevents overlay from being hidden
        event.stopPropagation();
    });

    // When previous button is clicked
    $prevButton.click(function (event) {
        // Hide the current image
        $('#overlay-ga img').hide();
        // Overlay image location
        var $currentImgSrc = $('#overlay-ga img').attr('src');
        // Image with matching location of the overlay image
        var $currentImg = $('#image-gallery-ga img[src="' + $currentImgSrc + '"]');
        // Finds the next image
        var $nextImg = $($currentImg.closest('.image-ga').prev().find('img'));
        // Fade in the next image
        $('#overlay-ga img').attr('src', $nextImg.attr('src')).fadeIn(800);
        // Prevents overlay from being hidden
        event.stopPropagation();
    });

    // When the exit button is clicked
    $exitButton.click(function () {
        // Fade out the overlay
        $('#overlay-ga').fadeOut('slow');
    });

    // Display thumbnails as color
    // const imgWithClassFlexActive = document.querySelector('.woocommerce-product-gallery ol li img.flex-active');
    // if (imgWithClassFlexActive) {
    //     console.log("Hiiiiiiiiiiiiii")
    //     imgWithClassFlexActive.parentElement.classList.add('flex-active-parent');
    // }

    //   Search display
    //   const searchDisplay = document.querySelector(".home-slider__top__search")
    //   const searchIcon = document.querySelector("li.has-child-click")
    //   searchIcon.addEventListener("click", () => {
    //     searchDisplay.style.display = "block";
    //   })
    // const searchDisplay = $(".home-slider__top__search");
    // const searchIcon = $("li.has-child-click");

    // searchIcon.click(function() {
    //   searchDisplay.css("transform", "translate(0, 0)");
    //   searchDisplay.toggle();
    // });
    const searchIcon = $('li.has-child-click');

    searchIcon.click(function () {
        const searchDisplay = $('.home-slider__top__search');
        searchDisplay.toggleClass('search-display');
    });

    // Header Change Back on scroll
    // $('document').on( 'scroll', function(){
    //     console.log('Event Fired');
    // });
    $(window).scroll(function () {
        if ($(window).scrollTop() >= 100) {
             $('header.main-header').css('background-color', '#2b2c43');
             $('.main-header__items').css('border', 'none');
        } else {
            $('header.main-header').css('background-color', 'transparent');
            $('.main-header__items').css('border-bottom', '1px solid #e1ded0');
        }
    });

    // Header Contact
    $(".main-header__contact").on("click", () => {
        $(".main-header__contactInfo").css("transform", "translateX(0%)");
    })

    $("#close-contact").on("click", () => {
        $(".main-header__contactInfo").css("transform", "translateX(100%)");
    })

    // Responsive menu
    $(".main-header__toggle").on("click", () => {
        $(".main-header__mobile-menu-toggleItems").css("transform", "translateX(0%)");
    })

    $("#resMenu").on("click", () => {
        $(".main-header__mobile-menu-toggleItems").css("transform", "translateX(100%)");
    })

    // Main About Slider
    
    var main_slider = new Swiper('.main-about__slider .myswiper', {
        // slidesPerView: 1,
        // spaceBetween: 0,
        // centeredSlides: 0,
        loop: true,
        // // effect: "fade",
        // // crossFade: true,
        speed: 2500,
        navigation: {
            nextEl: '.main-about__slider__button .swiper-button-next',
            prevEl: '.main-about__slider__button .swiper-button-prev',
        },
        // autoplay: {
        //     delay: 3500,
        //     disableOnInteraction: false,
        // },
        grabCursor: true,
        effect: "creative",
        creativeEffect: {
          prev: {
            shadow: true,
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
    });

    // Main Slider

    var main_slider = new Swiper('.main-slider .myswiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: 0,
        loop: true,
        effect: "fade",
        fadeEffect: {
        crossFade: false,
        },
        mousewheel: true,
        speed: 0,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
    });

    var about_slider = new Swiper('.page-view__about__slider .myswiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: 0,
        loop: true,
        speed: 4500,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        breakpoints: {
            // 992: {
            //     slidesPerView: 1
            // },
            // 768: {
            //     slidesPerView: 3
            // },
            // 480: {
            //     slidesPerView: 2
            // }
        },
    });

    var contact_slider = new Swiper('.page-view__about-main__slider .myswiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: 0,
        loop: true,
        speed: 4500,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
    });

    // Menu Responsive categories product
    $('.product_wrapper__topItems__responsive__cat ul li a').click(function () {
        console.log('Hiiiii');
        $('.product_wrapper__topItems__responsive__cat  ul li a').removeClass('activeCat');
        $(this).addClass('activeCat');
    });

    // display thumbnails products sliders as colors
    // var listItemWithFlexActive = document.querySelector('.woocommerce-product-gallery ol li img.flex-active').closest('li');
    // if (listItemWithFlexActive) {
    //     listItemWithFF.classList.add('class-active-parent');
    // }

    // Icon for add to shop basket in shop page
    let shopBtnIcons = document.querySelectorAll('li.product.type-product a.add_to_cart_button');
    shopBtnIcons.forEach(function (shopBtnIcon) {
        let spanBtnIcon = document.createElement('span');
        spanBtnIcon.className = 'kt-Basket';
        shopBtnIcon.appendChild(spanBtnIcon);
    });

    // let productBtnIcon = document.querySelector('div.product .sumamry form.cart .button')
    // let productSpanBtnIcon = document.createElement('span');
    // productSpanBtnIcon.className = 'kt-Basket';
    // productSpanBtnIcon.appendChild(productBtnIcon);

    // Button Category in Shop page
    // const btnCategory = document.querySelector(".btn-cat-shop");
    // btnCategory.addEventListener("click", () => {
    //     console.log("Hi")
    // })
    $('.btn-cat-shop').click(function () {
        $('#categoryOverlay').fadeIn();
    });

    // Function to close the overlay
    window.closeOverlay = function () {
        $('#categoryOverlay').fadeOut();
    };

    // Change text content of currency
    const wooCurrency = document.querySelectorAll('.woocommerce-Price-currencySymbol');
    wooCurrency.forEach((item) => {
        console.log('Hiiii');
        item.textContent = '';
    });

    // Add Code to Setting Responsive
    const btnSet = document.querySelector('.product_wrapper__topItems-res__toggle');
    const settingNav = document.querySelector('.product_wrapper__topItems__responsive__setting');
    if (btnSet) {
        btnSet.addEventListener('click', () => {
            settingNav.style.transform = 'translateX(0)';
            settingNav.style.right = 0;
        });
    }
    const btnSetClose = document.querySelector('.product-single__topItems-res__arrow button');
    if (btnSetClose) {
        btnSetClose.addEventListener('click', () => {
            settingNav.style.transform = 'translateX(-400px)';
            settingNav.style.right = '100%';
        });
    }
    const getPhotoUrl = (input) => {
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = function (e) {
                return e.target.result;
            };
            reader.readAsDataURL(input.files[0]);
        }
    };





    const getPhotoBlob = (input) => {
        return new Blob([input], { type: input.type })
        // console.log('%cfooter-scripts.js line:328 blob', 'color: #007acc;', blob);
        // // const reader = new FileReader();
        // reader.onload = function (e) {
        //     return new Blob([new Uint8Array(e.target.result)], { type: input.type });
        // };
        // reader.readAsArrayBuffer(input);


        // const reader = new FileReader();
        // reader.onloadend = function (e) {
        //     var arrayBuffer = e.target.result;
        //     var fileType = $('#file-type').value;
        //     var blob = blobUtil.arrayBufferToBlob(arrayBuffer, fileType)
    
        // };
        // reader.readAsArrayBuffer(file);
        // });
    };

    function handleSetUserProfilePhoto(input) {
        if (!input.target.files || !input.target.files[0]) {
            return false;
        }

        // const userPhotoUrl = getPhotoUrl(input.target);
        // const userPhotoBlob = getPhotoBlob(input.target);

        const userId = input.target.dataset.userId;
        const nonce = input.target.dataset.nonce;

        const formData = new FormData();

        formData.append('action', 'set_user_profile_photo');
        formData.append('nonce', nonce);
        formData.append('user_id', userId);
        formData.append('blob', input.target.files[0]);

        $.ajax({
            type: 'POST',
            // dataType: 'json',
            url: global_object.ajax_url,
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                console.log('%cfooter-scripts.js line:340 data', 'color: #007acc;', data);

                // Toast.fire({
                //     icon: data.status ? 'success' : 'error',
                //     title: data.message,
                // });
            },
            error: function (data) {
                console.error(data);
                // Toast.fire({
                //     icon: 'error',
                //     title: 'متاسفانه انجام نشد',
                //     footer: 'در ارسال درخواست مشکلی وجود دارد.',
                // });
            },
        });
    }

    const userProfilePhotoInput = document.getElementById('userProfilePhotoInput');
    userProfilePhotoInput?.addEventListener('change', handleSetUserProfilePhoto);

    // For popup mobile device logo
    window.addEventListener('load', function () {
        const popupContainer = document.getElementById('popup-container');
        if (popupContainer) {
            // Check if the current page is the home page
            const isHomePage = window.location.pathname === '/shop/';
            console.log('%cfooter-scripts.js line:400 isHomePage', 'color: #007acc;', isHomePage);
            if (window.innerWidth < 768 && isHomePage) {
                // Show the popup
                setTimeout(function () {
                    popupContainer.style.opacity = '0';
                    popupContainer.style.visibility = 'hidden';
                }, 2000);
            }
        } else {
            console.error("Element with ID 'popup-container' not found.");
        }
    });

    // // Add a class to the body based on the screen width
    // function updateBodyClass() {
    //     var body = document.body;
    //     var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    //     if (screenWidth < 768) {
    //     body.classList.add('body-mobile-v');
    //     } else {
    //     body.classList.remove('body-mobile-v');
    //     }
    // }
    //  // Run the function on page load and resize
    // document.addEventListener('DOMContentLoaded', updateBodyClass);
    // window.addEventListener('resize', updateBodyClass);

    //***  add parent dic to shop each product ***//
    var imgElements = document.querySelectorAll('.woocommerce ul.products li.product a img');
    imgElements.forEach(function (existingImage) {
        // Create a new div element
        var imageProductDiv = document.createElement('div');

        // Add the class 'image-product' to the new div
        imageProductDiv.className = 'image-product-woo';

        // Insert the new div before the existing image, and then move the image inside the div
        existingImage.parentNode.insertBefore(imageProductDiv, existingImage);
        imageProductDiv.appendChild(existingImage);
    });

    // Main Slider

    var review_slider_product = new Swiper('.woocommerce-Reviews .myswiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        // centeredSlides: 0,
        loop: true,
        // effect: "fade",
        speed: 2500,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // autoplay: {
        //     delay: 3500,
        //     disableOnInteraction: false,
        //   },
    });

    if ($('#main-search__bg').length) {
        var scene = document.getElementById('main-search__bg');
        var parallaxInstance = new Parallax(scene);
    }

    $('.social-home__item a').on('mouseover', function () {
        let title = $(this).data('title');
        $('#social_caption').html(title);
    });
    $('.social-home__item a').on('mouseleave', function () {
        $('#social_caption').html('');
    });

    // Produc Thumb Slider
    //=====================================================================

    var detail_image_thumb = new Swiper('.product-detail__image__thumb-slider .swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlide: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    // Mini Cart onClick
    const minicartButton = document.querySelector('.home-slider__top__basket span');
    const minicartDisplay = document.querySelector('.home-slider__top_minicart');
    if (minicartButton) {
        minicartButton.addEventListener('click', () => {
            console.log(minicartDisplay.style);
            minicartDisplay.classList.toggle('minicart-display');
        });
    }

    //Add icon to add to cart product
    // const iconShopContent = document.querySelector(".woocommerce div.product .summary.entry-summary form.cart .button");
    // if(iconShopContent) {

    // }

    // Add done for mobile devices
    function addTdForSmallScreens() {
        if (window.innerWidth < 768) {
            var rowsCart = document.querySelectorAll('table.cart .woocommerce-cart-form__cart-item');

            rowsCart.forEach(function (row) {
                var newTdCart = document.createElement('td');
                newTdCart.classList.add('product-cart-done');
                newTdCart.textContent = 'انجام شده';
                row.appendChild(newTdCart);
            });
            rowsCart.forEach(function (row) {
                var newTdCartText = document.createElement('td');
                newTdCartText.classList.add('product-cart-text');
                newTdCartText.textContent = ' تمامی اطلاعات خرید و پرداخت های شما ذخیره می شود.';
                row.appendChild(newTdCartText);
            });
        }
    }

    // Call the function initially and on window resize
    addTdForSmallScreens();

    // Produc Image Slider
    //=====================================================================

    var detail_image = new Swiper('.product-detail__image__main-slider .swiper-container', {
        simulateTouch: false,
        thumbs: {
            swiper: detail_image_thumb,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
    });

    $('.mobile-menu li.menu-item-has-children').click(function () {
        $(this).find('ul.sub-menu').slideToggle();
    });

    // Produc Image Zoom
    //=====================================================================

    // $('.zoom').zoom()

    // Gets background-color code from HTML and set --> Ex: data-bgcolor="#aaa222"
    //=====================================================================

    $('[data-bgcolor]').each(function (i, e) {
        $(e).css('background-color', $(e).data('bgcolor'));
    });

    // Gets color code from HTML and set --> Ex: data-color="#fff"
    //=====================================================================

    $('[data-color]').each(function (i, e) {
        $(e).css('color', $(e).data('color'));
    });

    var product_review = $('.product-detail__review__number').data('rate');
    $('.product-detail__review__inner label').on('mouseenter', function () {
        var rate = $(this).data('rate');
        $('.product-detail__review__number').html(rate);
    });

    $('.product-detail__review__inner').on('mouseleave', function () {
        $('.product-detail__review__number').html(product_rate);
    });

    $('.product-detail__review__inner label').on('click', function () {
        let $this = $(this);
        let parent = $(this).closest('.product-view__rating');
        let data = {};
        data['rate'] = $this.data('rate');
        data['postid'] = parent.data('postid');
        data['nonce'] = parent.data('nonce');
        data['action'] = 'product_rating';
        $('.product-detail__review__number').html(rate).attr('data-rate', rate);
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_object.ajax_url,
            data: data,
            success: function (data) {
                console.log(data);
                if (data.status == 1) {
                    Toast.fire({
                        icon: 'success',
                        title: 'با موفقیت انجام شد',
                        footer: data.message,
                    });
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'متاسفانه انجام نشد',
                        footer: data.message,
                    });
                }
            },
            error: function (data) {
                console.log(data);
                Toast.fire({
                    icon: 'error',
                    title: 'متاسفانه انجام نشد',
                    footer: 'در ارسال درخواست مشکلی وجود دارد.',
                });
            },
        });
    });

    $('.product-detail__buy__qty i').on('click', function () {
        let el = $(this);
        let type = el.data('type');
        let span = el.siblings('span');
        let input = el.siblings('input');
        let val = parseInt(span.data('value'));
        let max = parseInt(span.data('max'));
        let min = parseInt(span.data('min'));
        if (type == 'plus' && val < max) {
            input.val(val + 1);
            span.text(val + 1).data('value', val + 1);
        } else if (type == 'minus' && val > min) {
            input.val(val - 1);
            span.text(val - 1).data('value', val - 1);
        }
    });

    if ($('.product-detail__attrs').length) {
        variation_load();
    }

    $('.product-detail__attr__item input').on('click', function () {
        variation_load();
    });

    function variation_load() {
        var rel = '';
        $('.product-detail__attrs input:checked').each(function (i, e) {
            rel += ', ' + $(this).parent().data('rel');
        });
        var relation = rel.substring(2, rel.length);
        let data = {};
        data['productid'] = $('.product-detail__buy input[name="product_id"]').val();
        data['rel'] = relation;
        data['action'] = 'get_variation_price';
        $('.product-detail__price__current').addClass('loading');
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_object.ajax_url,
            data: data,
            success: function (data) {
                if (data.info.status == 1) {
                    $('.product-detail__price__current').html(data.info.price_html);
                    $('.product-detail__buy input[name="variation_id"]').val(data.info.variation_id);
                }
                $('.product-detail__price__current').removeClass('loading');
            },
            error: function (data) {
                Toast.fire({
                    icon: 'error',
                    title: 'متاسفانه انجام نشد',
                    footer: 'در ارسال درخواست مشکلی وجود دارد.',
                });
            },
        });
    }

    $('.product-detail__buy > a').on('click', function (e) {
        e.preventDefault();

        ($thisbutton = $(this)),
            ($form = $thisbutton.closest('.product-detail__buy')),
            (product_qty = $form.find('input[name=quantity]').val() || 1),
            (product_id = $form.find('input[name=product_id]').val()),
            (variation_id = $form.find('input[name=variation_id]').val() || 0);

        var data = {
            action: 'wc_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
        };

        $.ajax({
            type: 'post',
            url: global_object.ajax_url,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {
                Toast.fire({
                    icon: 'success',
                    title: 'به سبد خرید اضافه شد',
                });
            },
        });
    });

    // Ajax delete product in the cart
    $('.cart-box__item__remove').on('click', function (e) {
        e.preventDefault();

        var product_id = $(this).data('product-id'),
            cart_item_key = $(this).data('cart-item-key'),
            item = $(this).parent();

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_object.ajax_url,
            data: {
                action: 'wc_product_remove',
                product_id: product_id,
                cart_item_key: cart_item_key,
            },
            success: function (response) {
                console.log(response);
                item.remove();
                Toast.fire({
                    icon: 'success',
                    title: 'محصول از سبد خرید حذف شد',
                });
            },
        });
    });

    $('.myaccount__form__change').on('click', function () {
        let wrapper = $(this).data('account');
        $(this).parent().removeClass('active');
        $('.myaccount__wrapper#' + wrapper).addClass('active');
    });

    $('.cm-like-ajax').on('click', function (e) {
        e.preventDefault();
        let ele = $(this);
        let parent = $(this).parents('.comment-section__comments__list__item');
        let data = {};
        data['postid'] = parent.data('postid');
        data['commentid'] = parent.data('commentid');
        data['nonce'] = parent.data('nonce');
        data['type'] = ele.data('type');
        data['action'] = 's7n_comment_like';
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_object.ajax_url,
            data: data,
            success: function (data) {
                if (data.status == 1) {
                    ele.toggleClass('active');
                    if (ele.data('type') == 'like' && parent.find('.like-count')) {
                        parent.find('.like-count').html(data.info.count);
                    }
                    if (ele.data('type') == 'dislike' && parent.find('.dislike-count')) {
                        parent.find('.dislike-count').html(data.info.count);
                    }
                    Toast.fire({
                        icon: 'success',
                        title: 'با موفقیت انجام شد',
                        footer: data.message,
                    });
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'متاسفانه انجام نشد',
                        footer: data.message,
                    });
                }
            },
            error: function () {
                Toast.fire({
                    icon: 'error',
                    title: 'متاسفانه انجام نشد',
                    footer: 'در ارسال درخواست مشکلی وجود دارد.',
                });
            },
        });
    });

    $('.like-ajax').on('click', function (e) {
        e.preventDefault();
        let ele = $(this);
        let data = {};
        data['postid'] = ele.data('postid');
        data['nonce'] = ele.data('nonce');
        data['type'] = ele.data('type');
        data['action'] = 's7n_post_like';
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_object.ajax_url,
            data: data,
            success: function (data) {
                if (data.status == 1) {
                    Toast.fire({
                        icon: 'success',
                        title: 'با موفقیت انجام شد',
                        footer: data.message,
                    });
                    ele.toggleClass('active');
                    if (ele.find('.count')) {
                        ele.find('.count').html(data.info.count);
                    }
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'متاسفانه انجام نشد',
                        footer: data.message,
                    });
                }
            },
            error: function () {
                Toast.fire({
                    icon: 'error',
                    title: 'متاسفانه انجام نشد',
                    footer: 'در ارسال درخواست مشکلی وجود دارد.',
                });
            },
        });
    });

    //=============================//
    // r.dadkhah.tehrani@gmail.com //
    //=============================//
});
